import { createCaseSteps } from "../CaseFormFields";

export default function CaseCreateHeader({ step }) {
  const badge = step === 5 ? "Almost done" : `${Math.round(((step - 1) / 4) * 100)}% complete`;

  return (
    <div className="mb-2 font-plexsans">
      <div className="flex justify-between items-baseline mb-2">
        <span className="text-[11px] font-medium text-tan tracking-[.1em] uppercase font-plexmono">
          Step {step} of 5
        </span>
        <span className={`text-xs font-medium ${step === 5 ? "text-tan" : "text-[rgba(20,33,61,.4)]"}`}>
          {badge}
        </span>
      </div>

      <h2 className="font-spectral font-normal text-[28px] leading-[1.3] text-navy mb-1.5">
        {createCaseSteps[step - 1].title}
      </h2>
      <p className="text-[14.5px] leading-relaxed text-[rgba(20,33,61,.55)] mb-0">
        {createCaseSteps[step - 1].subtitle}
      </p>
    </div>
  );
}
